/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSignalHPlus = createReactComponent("signal-h-plus", "IconSignalHPlus", [
  ["path", { d: "M7 16v-8", key: "svg-0" }],
  ["path", { d: "M11 8v8", key: "svg-1" }],
  ["path", { d: "M7 12h4", key: "svg-2" }],
  ["path", { d: "M14 12h4", key: "svg-3" }],
  ["path", { d: "M16 10v4", key: "svg-4" }]
]);

export { IconSignalHPlus as default };
//# sourceMappingURL=IconSignalHPlus.js.map
